var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContactHelp = function SvgIconContactHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 52,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 51.2,
    x: 0.5,
    y: 0.2,
    fill: "#EDECEC",
    rx: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_contact_help_svg__a",
    width: 25,
    height: 24,
    x: 12,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M12.5 14h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_contact_help_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4F4440",
    d: "M16.808 33.5q-.758 0-1.283-.525A1.75 1.75 0 0 1 15 31.692V20.308q0-.758.525-1.283t1.283-.525h15.384q.758 0 1.283.525T34 20.308v11.384q0 .758-.525 1.283t-1.283.525zm7.692-6.942 8-5.116L32.346 20 24.5 25l-7.846-5-.154 1.442z"
  }))));
};
export default SvgIconContactHelp;